import { render, staticRenderFns } from "./YourRoutineSection.vue?vue&type=template&id=fa4da80c&scoped=true&"
import script from "./YourRoutineSection.vue?vue&type=script&lang=js&"
export * from "./YourRoutineSection.vue?vue&type=script&lang=js&"
import style0 from "./YourRoutineSection.vue?vue&type=style&index=0&id=fa4da80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4da80c",
  null
  
)

export default component.exports